import { useRecipeV2Summary, useStandardRecipeV2 } from '@ctcells/api'
import { dataSourceFor } from '@ctcells/core'
import { errorMessage } from '@ctcells/i18n'

import { useScreenAccess } from '../screenAccess.ts'

import { RecipeTemplateDetail } from './RecipeTemplatesScreen.tsx'

/**
 * 「레시피」 템플릿 오른쪽 판 컨테이너 — `GET /recipes/standard` · `POST /recipes/summary`. 목록 한 줄은 템플릿 목록(`TemplatesContainer`)이 받는다.
 * 🔴 작업 템플릿 목록은 받지 않는다 — 작업 차례를 다른 템플릿과 잇거나 견주지 않는다(eric 2026-10-26 「응.. 다 빼줘」).
 * 🔴 데이터 소스는 `recipes` 도메인을 따른다(템플릿 컨테이너와 같다). 목(데모)에서는 문서가 없어 판이 빈다 — 목 문서를 지어 세우지 않는다.
 */
export function RecipeTemplateDetailContainer({ onClose }: { onClose: () => void }) {
  const access = useScreenAccess()
  const live = dataSourceFor('recipes') !== 'demo'
  const standard = useStandardRecipeV2({ skip: !live })
  const summary = useRecipeV2Summary({ doc: standard.data, cacheId: 'standard', skip: !live })
  const error = standard.error ?? summary.error
  return (
    <RecipeTemplateDetail
      access={access}
      doc={standard.data}
      loading={live && (standard.isPending || summary.isPending)}
      onClose={onClose}
      summary={summary.data}
      {...(error === null ? {} : { error: errorMessage(error) })}
    />
  )
}
